export default __webpack_public_path__ + "static/media/round-content-add.d178241f.svg";